import '../assets/css/app.css'

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className=''>
      <hr />
      <div className='float-start'>
        <p>{currentYear} &copy; All rights reserved by <b> <a target="_blank" href='https://auis.edu.krd/' > AUIS</a></b></p>
      </div>
    </div>
  )
}

export default Footer
